module.exports = __webpack_public_path__ + "static/media/chenyiru.db985981.png";